import React, {useState} from "react";
import {Alert, Snackbar} from "@mui/material";

type Props = {
    // Set by the server while a catch-up refresh is running for a report whose imports were paused
    refreshStarted?: number | null;
}

const DataRefreshNotice = ({refreshStarted}: Props) => {
    const [open, setOpen] = useState(Boolean(refreshStarted));

    return <Snackbar open={open} anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert severity="info" variant="filled" onClose={() => setOpen(false)} sx={{width: '100%'}}>
            Welcome back! Your report hasn't been updated in a while, so we're refreshing it now.
            Fresh data should appear within about 2 hours.
        </Alert>
    </Snackbar>
}

export default DataRefreshNotice;
